import { call, put } from 'redux-saga/effects';

import api from 'api';

import { setGuides, setLoadingState } from 'store/guides/actions';
import { notifyError } from 'store/notifications/actions';

import { IGuide } from 'pages/guides/types';

export function* getGuides() {
    try {
        const { data }: { data: IGuide[] } = yield call(api.user.getProducts);

        yield put(setGuides(data));
        yield put(setLoadingState(false));
    } catch (error) {
        notifyError({ message: 'getGuides error' });
    }
}
